<template>
  <div class="flex flex_col performance">
    <!-- 上面的选择 -->
    <div class="selects">
      <el-form
        :model="queryParam"
        ref="ruleform"
        :inline="true"
        class="flex flex_ju_sb warnform-inline"
      >
        <div class="form-inputs">
          <el-form-item
            label="选择生产区域"
            style="margin-right: 10px"
            v-if="isShowAllSelect"
          >
            <el-select
              v-model="allOrgId"
              :placeholder="orgAllSelect.length ? '请选择' : '暂无设备'"
              @change="changeAllOrg"
            >
              <el-option
                v-for="(item, index) in orgAllSelect"
                :key="index"
                :value="item.orgId"
                :label="item.orgName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="isShowAllSelect ? '' : '选择生产区域'"
            :class="{ 'form-item-had': isShowAllSelect }"
          >
            <el-select
              placeholder="请选择区域"
              v-model="queryParam.orgId"
              @change="changeOrg"
            >
              <el-option
                v-for="(item, index) in orgSelect"
                :key="index"
                :value="item.orgId"
                :label="item.orgName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择设备">
            <el-select
              placeholder="请选择设备"
              v-model="queryParam.deviceName"
              clearable
            >
              <el-option
                v-for="(item, index) in deviceSelect"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择时间" class="form-picker">
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.startTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div picker-div2"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                :clearable="true"
                :picker-options="pickerOptions0"
                :editable="false"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>

            <span class="pick-word">至</span>
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.endTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div picker-div2"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                :clearable="true"
                :picker-options="pickerOptions1"
                :editable="false"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>
          </el-form-item>
        </div>

        <el-form-item class="form-btns">
          <el-button type="primary" @click="searchClick">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格和图表 -->
    <div
      v-loading="loading"
      style="
        margin-top: 0.19rem;
        flex: 1;
        min-height: 610px;
        background-color: transparent;
      "
    >
      <div class="flex flex_ju_sb bottom-content" v-if="tableData.length">
        <!-- 下面的表格 -->
        <div class="flex flex_col warn-tables">
          <div class="table-title">设备操作日志</div>
          <el-table
            :data="tableData"
            class="tables"
            :height="535"
            :stripe="true"
            align="center"
            header-cell-class-name="header-cell"
            cell-class-name="table-cell"
          >
            <el-table-column
              type="index"
              label="序号"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="deviceName"
              label="设备名称"
              width="150"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="actionName"
              label="操作项"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="respTime"
              label="操作时间"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="actionSourceName"
              label="操作来源"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <!-- 占位数据 -->
            <div slot="empty" class="table-empty">
              <img
                class="table-noimg"
                src="@/assets/image/home/img_none.png"
                alt=""
              />
              <div class="table-emptyword">请选择设备类型！</div>
            </div>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            class="pagination"
            layout="prev, pager, next"
            :current-page.sync="ipagination.currentPage"
            :page-size="ipagination.pageSize"
            :total="ipagination.total"
            :hide-on-single-page="true"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
        <!-- 右边的图表 -->
        <div class="perform-chart">
          <div class="table-title">设备操作频次占比分析</div>
          <div class="charts" id="performChart" ref="performChart"></div>
        </div>
      </div>
      <div class="table-empty bottom-empty" v-else>
        <img
          class="table-noimg"
          src="@/assets/image/home/img_none.png"
          alt=""
        />
        <div class="table-emptyword">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 告警信息
 */
import tableMinin from "@/mixins/TableMinin";
import { prevDayTime, monthStartDay, todayTime } from "../../times/moment";
let index100 = -1;
var pieTime100;
export default {
  mixins: [tableMinin],
  data() {
    const self = this;
    return {
      orgAllSelect: [], // 生产区域下拉选
      allOrgId: "", /// 分公司下面选中的orgid
      ifUseLoadBack: false,
      isMakeTime: false,
      isTranPage: true,
      isFillTime: true,
      loading: true,
      // 表格数据
      tableData: [],
      orgSelect: [],
      deviceSelect: [], // 选择设备下拉选
      isDelEmpty: true,
      url: {
        list: self.$api.setfindDeviceList,
      },
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.queryParam.endTime) {
            if (this.queryParam.endTime != "") {
              let num = new Date(this.queryParam.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum =
              new Date(this.queryParam.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
    };
  },
  created() {
    this.$set(this.queryParam, "startTime", `${monthStartDay()}`);
    this.$set(this.queryParam, "endTime", `${todayTime()}`);
  },
  mounted() {
    // 获取生产区域
    // this.$set(this.queryParam, 'orgId', '')

    // TODO
    // // 获取操作日志列表
    // this.loadData(1)
    // // 获取右侧饼图数据
    // this.getPieData()
    // this.getOrgids()
    // 获取设备
    // this.getEquipSelect()

    if (this.isShowAllSelect) {
      // 获取上面的生产区域信息
      this.getAllOrgids();
    } else {
      this.getOrgids();
    }
  },
  methods: {
    getOrgids(isFen = false, isRequest = true) {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        parentOrgId: "",
        type: "3",
      };
      if (isFen) {
        params.parentOrgId = this.allOrgId;
      } else {
        params.parentOrgId = userInfos.orgId;
      }
      console.log(params);
      this.$set(this.queryParam, "deviceName", ""); //清空设备选择项
      this.$http
        .getAction(this.$api.findChildOrgByParentOrgId, params)
        .then((res) => {
          console.log(res);
          if (res.meta.success) {
            let datas = res.data || [];
            this.orgSelect = datas || [];
            if (datas && datas.length) {
              this.$set(this.queryParam, "orgId", datas[0]["orgId"]);
              // 获取页面上相关的其它数据
              setTimeout(() => {
                // 获取设备
                this.getEquipSelect();
                if (isRequest) {
                  // 获取操作日志列表
                  this.loadData(1);
                  // 获取右侧饼图数据
                  this.getPieData();
                }
              }, 300);
            } else {
              this.$set(this.queryParam, "orgId", "");

              this.loading = false;
              this.deviceSelect = [];
            }
          } else {
            this.orgSelect = [];
            this.loading = false;
            this.deviceSelect = [];
          }
        })
        .catch(() => {
          this.orgSelect = [];
          this.loading = false;
          this.deviceSelect = [];
        });
    },
    getAllOrgids() {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        parentOrgId: userInfos.orgId,
        type: "2",
      };
      this.$http
        .getAction(this.$api.findChildOrgByParentOrgId, params)
        .then((res) => {
          console.log(res);
          if (res.meta.success) {
            let datas = res.data || [];
            this.orgAllSelect = datas || [];
            if (datas && datas.length) {
              this.allOrgId = datas[0]["orgId"];
              this.getOrgids(true);
            } else {
              this.loading = false;
            }
          } else {
            this.orgSelect = [];
            this.loading = false;
          }
        })
        .catch(() => {
          this.orgSelect = [];
          this.loading = false;
        });
    },
    changeAllOrg(val) {
      this.allOrgId = val;
      this.orgSelect = [];
      this.$set(this.queryParam, "orgId", "");
      this.getOrgids(true, false);
    },
    // 获取设备
    getEquipSelect() {
      let params = {
        orgId: this.queryParam.orgId,
      };

      this.$http
        .getAction(this.$api.setfindDeviceNameGroup, params)
        .then((res) => {
          if (res.meta.success) {
            let datas = res.data || [];
            this.deviceSelect = datas || [];
          } else {
            this.deviceSelect = [];
          }
        })
        .catch(() => {
          this.deviceSelect = [];
        });
    },
    changeOrg() {
      this.deviceSelect = [];
      this.$set(this.queryParam, "deviceName", "");
      this.getEquipSelect();
    },
    // 查询按钮点击
    searchClick() {
      this.$refs["ruleform"].validate((valid) => {
        if (valid) {
          this.loadData(1);
          this.getPieData();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    loadData(arg) {
      if (!this.url.list || this.url.list == "") {
        this.$message("请设置url.list属性!", "error");
        return;
      }
      if (arg === 1) {
        this.ipagination.currentPage = 1;
      }
      this.loading = true;
      let params = this.getQueryParams();
      if (this.isDelEmpty) {
        if (params.deviceName == "") {
          this.$delete(params, "deviceName");
        }
      }
      // 判断用户的orgid
      if (!params.orgId || params.orgId == "") {
        let userInfo = this.getItem("wlwUserInfo") || {};
        let userInfos = JSON.parse(userInfo);
        if (this.isShowAllSelect) {
          // 说明是分公司
          // 赋值网点id
          if (this.allOrgId && this.allOrgId != "") {
            this.$set(params, "orgId", this.allOrgId);
          } else {
            this.$set(params, "orgId", userInfos.orgId);
          }
        } else {
          // 网点数据

          this.$set(params, "orgId", userInfos.orgId);
        }
      }
      this.$http
        .postAction(this.url.list, params)
        .then((res) => {
          // 判断走公共赋值还是单独数据处理
          if (this.ifUseLoadBack) {
            if (res.meta.success) {
              let datas = res.data || {};
              if (datas) {
                // 分页数据的赋值
                if (datas.totalElements) {
                  this.ipagination.total = Number(datas.totalElements);
                  this.ipagination.pageSize = datas.size;
                } else {
                  this.ipagination.total = 0;
                  this.ipagination.pageSize = 10;
                }
                // 判断走公共赋值还是单独数据处理
                this.tableData = datas || [];
              }
            }
          } else {
            let datas = res;
            // 回到页面各自独立的数据处理
            this.loadBack(datas);
          }
        })
        .finally((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .catch(() => {
          this.loading = false;
          this.isLine = false;
        });
    },
    // 获取右侧饼图数据
    getPieData() {
      // let params = {
      // 	orgId: this.queryParam.orgId,
      // }
      // this.peiChart()
      let params = this.getQueryParams();
      if (params.deviceName == "") {
        this.$delete(params, "deviceName");
      }
      if (!params.orgId || params.orgId == "") {
        let userInfo = this.getItem("wlwUserInfo") || {};
        let userInfos = JSON.parse(userInfo);
        if (this.isShowAllSelect) {
          // 说明是分公司
          // 赋值网点id
          if (this.allOrgId && this.allOrgId != "") {
            this.$set(params, "orgId", this.allOrgId);
          } else {
            this.$set(params, "orgId", userInfos.orgId);
          }
        } else {
          // 网点数据

          this.$set(params, "orgId", userInfos.orgId);
        }
      }
      this.$http
        .postAction(this.$api.setfindDeviceActionCount, params)
        .then((res) => {
          if (res.meta.success) {
            let datas = res.data || [];
            if (datas && datas.length) {
              let endData = [];
              datas.forEach((item) => {
                endData.push({
                  name: item.actionName,
                  value: Number(item.num),
                });
              });
              setTimeout(() => {
                this.peiChart(endData);
              }, 1000);
            }
          }
        });
    },
    // 右侧图表绘制
    peiChart(datas) {
      console.log(datas);
      // let datas = [
      // 	{
      // 		name: '上升',
      // 		value: 10,
      // 	},
      // 	{
      // 		name: '停止',
      // 		value: 5,
      // 	},
      // 	{
      // 		name: '下降',
      // 		value: 8,
      // 	},
      // ]
      let colors = ["#2DAEA9", "#91CC75", "#5C7BD9", "#5E5CD9", "#D95CC9"];
      let myChart = this.$echarts.init(this.$refs.performChart);
      let option = {
        tooltip: {
          show: false,
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
          // selectedMode: false,
        },
        color: colors,
        series: [
          {
            name: "",
            type: "pie",
            radius: ["45%", "65%"],
            avoidLabelOverlap: false,
            selectedOffset: 28,
            label: {
              show: false,
              position: "center",
              formatter: function (params) {
                console.log(params);
                return (
                  "{b|" +
                  params.name +
                  "}\n\n" +
                  "{a|" +
                  params.value +
                  "}{b|次}"
                );
              },
              rich: {
                a: {
                  color: "#000",
                  align: "center",
                  fontSize: 24,
                  fontWeight: "bold",
                },
                b: {
                  color: "#333333",
                  align: "center",
                  fontSize: 20,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
              },
            },
            labelLine: {
              show: false,
            },
            data: datas,
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
      this.pieActive(myChart, option);
      // myChart.on("mouseover", () => {
      //   clearInterval(pieTime100);
      //   myChart.dispatchAction({
      //     type: "downplay",
      //     seriesIndex: 0,
      //     dataIndex: index100,
      //   });
      // });
      // myChart.on("mouseout", () => {
      //   this.pieActive(myChart, option);
      // });
      $("#performChart").mouseenter(() => {
        clearInterval(pieTime100);
        myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: index100,
        });
      });
      $("#performChart").mouseleave(() => {
        this.pieActive(myChart, option);
      });
    },
    pieActive(myChart, option) {
      clearInterval(pieTime100);
      index100 = -1; //高亮所在下标
      let dataLength = option.series[0].data.length; // 当前饼图有多少个扇形
      // 用定时器控制饼图高亮
      pieTime100 = setInterval(() => {
        // 清除之前的高亮
        myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: index100,
        });
        index100 = (index100 + 1) % dataLength;
        // 当前下标高亮
        myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: index100,
        });
        if (index100 > dataLength) {
          index100 = 0;
        }
      }, 2000);
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/formtable.scss";
.warnform-inline {
  .form-inputs {
    .el-form-item {
      &:not(:last-child) {
        margin-right: 2.16vw;
      }
      &.form-item-had {
        margin-right: 2.5vw;
        .el-select {
          width: 3rem;
        }
      }
    }
    .form-item-area {
      margin-right: 10px !important;
    }
  }
}
@media screen and (max-width: 1585px) {
  .warnform-inline {
    .form-inputs {
      .el-form-item {
        &:not(:last-child) {
          margin-right: 2vw;
        }
        &.form-item-had {
          margin-right: 2vw;
        }
      }
      .el-select {
        width: 2.5rem;
      }
    }
  }
}
@media screen and (max-width: 1370px) {
  .warnform-inline {
    .form-inputs {
      .el-form-item {
        &:not(:last-child) {
          margin-right: 1.3vw;
        }
        &.form-item-had {
          margin-right: 1.3vw;
          .el-select {
            width: 2.3rem;
          }
        }
      }
    }
  }
}
.performance {
  height: 100%;
  // 下面的内容
  .bottom-content {
    // margin-top: 0.19rem;

    height: 100%;
    min-height: 610px;
    .table-title {
      font-size: 0.2rem;
      color: #333;
      text-align: left;
      padding: 0.19rem 0 0.29rem 0.36rem;
    }
  }
  .warn-tables {
    margin-top: 0;
    width: 12.29rem;
    padding-bottom: 0.15rem;
    .tables {
      border-radius: 0;
    }
  }
  // 分页
  .pagination {
    padding-top: 0;
  }
  // 右侧图表数据
  .perform-chart {
    width: 7.53rem;
    height: 100%;
    background: #ffffff;
    border-radius: 0.19rem;
    .charts {
      width: 7.53rem;
      height: 91.5%;
    }
  }

  // 空数据
  .bottom-empty {
    width: 100%;
    height: 100%;
    // height: 8.89rem;
    background: #ffffff;
    border-radius: 0.19rem;
    // margin-top: 0.19rem;
    padding-top: 2.35rem;
    .table-noimg {
      width: 3.06rem;
      height: 2.45rem;
    }
    .table-emptyword {
      // color: #c8c8c8;
      font-size: 0.23rem;
    }
  }
}
</style>
